export enum ComponentCategory {
    Text,
    Button,
    Data,
    Media,
    ExternalContent,
    Layout,
    Other
}